import { useEffect } from "react";

/**
 * Escape zooms out one level — the same reflex on every drill screen.
 *
 * Ignores Escape pressed while the reader is typing (inputs, textareas,
 * selects, contentEditable) so it never steals a field's own escape
 * behaviour. Listener is added on mount and removed on unmount.
 */
export default function useEscapeBack(onBack, enabled = true) {
  useEffect(() => {
    if (!enabled || typeof onBack !== "function") return undefined;
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      const el = e.target;
      const tag = el?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el?.isContentEditable) return;
      onBack(e);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onBack, enabled]);
}
